import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center" }

import { reactive, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import type { FormInstance } from "element-plus";
import PaymentService from "../services/PaymentService";
import { creditAdjustTypes } from "@/core/types/CreditAdjustTypes";
import { useI18n } from "vue-i18n";
import Decimal from "decimal.js";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeAdjustForm',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = useI18n().t;
const isLoading = ref(true);
const showOption = ref(true);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const finalData = ref<any>();
const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  accountId: [
    { required: true, message: "Please input Login", trigger: "blur" },
  ],
  amount: [
    { required: true, message: "Please input Amount", trigger: "blur" },
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value == 0) {
          callback(new Error("Amount must be greater or  than 0"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  comment: [
    { required: true, message: "Please input Remark", trigger: "blur" },
  ],
});

const formData = ref<any>({
  accountId: 0,
  amount: 0,
  comment: "",
  type: creditAdjustTypes.Adjust,
});

const show = async (_accountId = 0, options = null) => {
  isLoading.value = true;
  processOptions(options);
  modalRef.value?.show();
  resetForm();
  formData.value.accountId = _accountId;
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

const processOptions = (options: any) => {
  if (!options) return;
  if (options == "hideLoginNo") {
    showOption.value = false;
  }
};

const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  isLoading.value = true;
  await ruleFormRef.value.validate(async (valid) => {
    isValid = valid;
  });
  if (!isValid) {
    isLoading.value = false;
    return;
  }
  try {
    const res = await PaymentService.getAccountIdByAccountNumber(
      formData.value.accountId
    );
    finalData.value = {
      ...formData.value,
      amount: new Decimal(formData.value.amount).times(100).toNumber(),
    };
    finalData.value.accountId = res.data[0].id;
    await PaymentService.createAdjustRecord(finalData.value);
    emits("eventSubmit");
    MsgPrompt.success("success");
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
  hide();
};

// const submit = async () => {
//   if (!ruleFormRef.value) return;
//   let isValid = false;
//   await ruleFormRef.value.validate(async (valid, fields) => {
//     isValid = valid;
//   });
//   if (!isValid) return;
//   try {
//     const res = await PaymentService.getAccountIdByAccountNumber(
//       formData.value.accountId
//     );

//     finalData.value = { ...formData.value };
//     finalData.value.accountId = res.data[0].id;

//     await PaymentService.createCredit(
//       finalData.value.accountId,
//       finalData.value
//     );

//     emits("eventSubmit");
//     MsgPrompt.success("success");
//   } catch (error) {
//     MsgPrompt.error(error);
//   }
//   hide();
// };

const resetForm = () => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.resetFields();
};



__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.changeAdjust'),
    "is-loading": isLoading.value,
    submit: submit,
    style: {"width":"450px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: formData.value,
            rules: rules,
            "label-width": "70px",
            class: "demo-ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_form_item, {
                label: "Login",
                prop: "accountId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "Input Login",
                    modelValue: formData.value.accountId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.accountId) = $event)),
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 512), [
                [_vShow, showOption.value]
              ]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.amount'),
                prop: "amount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.amount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.amount) = $event)),
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.remark'),
                prop: "comment"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.comment,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.comment) = $event)),
                    maxlength: "40",
                    "show-word-limit": "",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})